import React, { Fragment } from "react";

const DiscussionUserItem = ({
  user,
  clearUsers,
  setUser,
  User,
  discussion,
  setDiscussion,
}) => {
  let foundInvite;

  function checkInvited() {
    if (discussion.invites && discussion.invites.length > 0) {
      foundInvite = discussion.invites.find((x) => {
        return x.channelid === User.channelid;
      });
    }
  }

  return (
    <Fragment>
      <div className="user-section">
        <div className="friends-user-container">
          <div className="friend-user-avi-container">
            <div className="avi-color-border green">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                className="friend-user-avi"
                alt="avatar"
              />
            </div>
          </div>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">{user.channelid}</span>
                </li>
                <li className="user-online-item">
                  {user.firstname} {user.lastname}
                </li>
                <li className="user-online-item">{user.jobtitle}</li>
                <li className="user-online-item">
                  {user.location.city}, {user.location.state}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="friends-buttons-container">
          <div className="friend-button-container">
            {!foundInvite && (
              <button
                className="friend-button background-green"
                onClick={() => {
                  checkInvited();

                  setUser({
                    user: user.user,
                    channelid: user.channelid,
                    avatar: user.avatar,
                    firstname: user.firstname,
                    lastname: user.lastname,
                    jobtitle: user.jobtitle,
                    location: {
                      city: user.location.city,
                      state: user.location.state,
                    },
                  });

                  if (User.channelid !== "" && !foundInvite) {
                    setDiscussion({
                      ...discussion,
                      invites: [...discussion.invites, User],
                    });
                    setUser({
                      user: "",
                      channelid: "",
                      avatar: "",
                      firstname: "",
                      lastname: "",
                      jobtitle: "",
                      location: { city: "", state: "" },
                    });
                    clearUsers();
                  }
                }}
              >
                <i className="fas fa-vote-yea mx-5"></i>
                Invite
              </button>
            )}
            {foundInvite && User.channelid === user.channelid && (
              <button className="friend-button background-black">
                <span className="white bold flex-only">
                  <i className="fa-regular fa-circle-check white fa-sm mr-10"></i>
                  Invited
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionUserItem;
